import { render, staticRenderFns } from "./room-information.vue?vue&type=template&id=b9cda28c&scoped=true"
import script from "./room-information.vue?vue&type=script&lang=js"
export * from "./room-information.vue?vue&type=script&lang=js"
import style0 from "./room-information.vue?vue&type=style&index=0&id=b9cda28c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cda28c",
  null
  
)

export default component.exports